import React, { useState, useEffect, useContext, useRef } from 'react';
import {AnimatePresence, motion} from 'framer-motion';
import { useUserAPI } from '../../components/useUserAPI';
import { ShoppingStart } from '../../components/ShoppingStart';

// import useSound from 'use-sound';
// import se_03 from '../../sound/s03_item_change.mp3';
// import se_08 from '../../sound/s08_se_delay0.mp3';

const changeMotion01 = {
	initial: {
		y: "100%",
		opacity: 1,
	},
	animate: {
		y: 0,
		opacity: 1,
	},
	hidden: {
		y: "100%",
		opacity: 1,
	},
};
const changeMotion02 = {
	initial: {
		y: -20,
		opacity: 0,
	},
	animate: {
		y: 0,
		opacity: 1,
	},
	hidden: {
		y: 20,
		opacity: 0,
	},
};
const noBarcode_cover = {
	initial: {
		opacity: 0,
	},
	animate: {
		opacity: 0.55,
	},
	hidden: {
		opacity: 0,
	},
};

export const ItemNum = (props) => {


//----------------------------------------
//数量追加・変更モーダルCLOSE
//----------------------------------------

const closeModal = (e) => {
	e.stopPropagation();
	props.setShowItemNum([]);
	setIsDisabled(false);
	// se08_se();
	props.setSoundState("se08_se");
}

const closeModalNoSound = (e) => {
	e.stopPropagation();
	props.setShowItemNum([]);
	setIsDisabled(false);
}


//----------------------------------------
//数量追加・変更、KeyPLU商品登録
//----------------------------------------

//商品個数変更API
const { changeAPI, data: changeData, loading: changeLoading, error: changeError } = useUserAPI();
const ShoppingStartContext = useContext(ShoppingStart);

//KeyPLU商品登録API
const { keyplupurchaseAPI, data: keyplupurchaseData, loading: keyplupurchaseLoading, error: keyplupurchaseError } = useUserAPI();

//数量追加・変更ボタン無効フラグ
const [isDisabled, setIsDisabled] = useState(false);
const [isRequesting, setIsRequesting] = useState(false);
const [lastClickTime, setLastClickTime] = useState(0);

useEffect(() => {
	console.log("isDisabled: " + isDisabled);
	console.log("isRequesting: " + isRequesting);
	console.log("lastClickTime: " + lastClickTime);
}, [isDisabled, isRequesting, lastClickTime]);

//数量追加・変更ボタン
const onSelectNum = (bnum) => {
	console.log("changeNum_btn: click");
	console.log("isDisabled: " + isDisabled);
	console.log("isRequesting: " + isRequesting);
	console.log("lastClickTime: " + lastClickTime);
	const now = Date.now();
	if (now - lastClickTime < 1000) { // 1000ms以内の連打を防ぐ
		console.log("changeNum_btn: 連打防止");
		return;
	}else {
		setLastClickTime(now);

		if(isDisabled === false && isRequesting === false){
			console.log("changeNum_btn: 有効");
			setIsDisabled(true);
			setIsRequesting(true);

			let bundleList = [];
			let singleList = [];
			const bcode = props.showItemNum[0];

			// 現在の状態を保存
			const currentState = {
				showItemNum: props.showItemNum,
				shoppingData: props.shoppingData
			};

			if(props.showItemNum[2] === "add"){ //追加
				if(props.shoppingData.data){
					if(props.shoppingData.data.resultItemMasterList){
						console.log(props.shoppingData.data.resultItemMasterList);
						bundleList = props.shoppingData.data.resultItemMasterList.filter(function(item) {
							if(item.itemList){
								return item.itemList[0].barCode === bcode;
							}
						});
						singleList = props.shoppingData.data.resultItemMasterList.filter(function(item) {
							return item.barCode === bcode;
						});
					}else{
						console.log(props.shoppingData.data.saleList);
						bundleList = props.shoppingData.data.saleList.filter(function(item) {
							if(item.itemList){
								return item.itemList[0].barCode === bcode;
							}
						});
						singleList = props.shoppingData.data.saleList.filter(function(item) {
							return item.barCode === bcode;
						});
					}
				}
				props.setShowItemNum([bcode,bnum,"add"]);
				console.log("bundleList:");
				if(bundleList.length > 0){
					console.log(bundleList.length * bundleList[0].qualifyingitemcount);
				}
				console.log("singleList:");
				if(singleList.length > 0){
					console.log(singleList[0].count);
				}else {
					console.log("0");
				}
			}else{ //変更
				document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
					element.classList.add('is_show');
				});

				if(props.shoppingData.data.resultItemMasterList){
					console.log(props.shoppingData.data.resultItemMasterList);
					bundleList = props.shoppingData.data.resultItemMasterList.filter(function(item) {
						if(item.itemList){
							return item.itemList[0].barCode === bcode;
						}
					});
				}else{
					console.log(props.shoppingData.data.saleList);
					bundleList = props.shoppingData.data.saleList.filter(function(item) {
						if(item.itemList){
							return item.itemList[0].barCode === bcode;
						}
					});
				}
				props.setGetAtChange(true);
				props.setShowItemNum([bcode,bnum,"change"]);
				console.log("bundleList:");
				console.log(bundleList);
				console.log("bundleList.length: " + bundleList.length);
				if(bundleList.length > 0){//バンドル内の点数
					console.log("bundleList[0].qualifyingitemcount: " + bundleList[0].qualifyingitemcount);
				}
				console.log("singleList:");
				if(singleList.length > 0){
					console.log(singleList[0].count);
				}else {
					console.log("0");
				}
			}

			// 状態が変更されていないことを確認
			if(JSON.stringify(currentState) === JSON.stringify({
				showItemNum: props.showItemNum,
				shoppingData: props.shoppingData
			})) {
				// デバウンス処理
				setTimeout(() => {
					if(bundleList.length !== 0){ //バンドル商品
						let qualifyingitemcount = 0;
						if(bundleList.length > 0){
							qualifyingitemcount = bundleList[0].qualifyingitemcount;
							console.log("qualifyingitemcount: " + qualifyingitemcount);
						}
						let bundlenum;
						if(singleList.length > 0){
							bundlenum = bnum + (bundleList.length * qualifyingitemcount) + singleList[0].count;
						}else{
							bundlenum = bnum + (bundleList.length * qualifyingitemcount);
						}
						console.log("bundlenum:"+bundlenum);
						if(props.showItemNum[1] === bnum && props.showItemNum[2] !== "add"){
							console.log("changeAPI: nocall");
							console.log("個数変更なし");
							props.setShowItemNum([]);
							setIsDisabled(false);
							setIsRequesting(false);

							document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
								if (element) {
									element.classList.remove('is_show');
								}
							});
						}else{
							if(props.showItemNum[2] === "add"){ //追加
								console.log("keyplupurchaseAPI: call");
								//KeyPLU商品登録API（countは加算されるため追加分のみ送信
								keyplupurchaseAPI(ShoppingStartContext.data.token,bcode,bnum)
									.finally(() => {
										setIsDisabled(false);
										setIsRequesting(false);
									});
							}else{ //変更
								console.log("changeAPI: call");
								//商品個数変更API
								changeAPI(ShoppingStartContext.data.token,bcode,bundlenum)
									.finally(() => {
										setIsDisabled(false);
										setIsRequesting(false);
									});
							}
						}
					}else{ //通常商品
						if(singleList.length > 0){
							let singlenum = bnum + singleList[0].count;
							console.log("changeAPI: call");
							console.log("singlenum:"+singlenum);

							if(props.showItemNum[2] === "add"){ //追加
								console.log("keyplupurchaseAPI: call");
								//KeyPLU商品登録API（countは加算されるため追加分のみ送信
								keyplupurchaseAPI(ShoppingStartContext.data.token,bcode,bnum)
									.finally(() => {
										setIsDisabled(false);
										setIsRequesting(false);
									});
							}else{ //変更
								console.log("changeAPI: call");
								//商品個数変更API
								changeAPI(ShoppingStartContext.data.token,bcode,singlenum)
								.finally(() => {
									setIsDisabled(false);
									setIsRequesting(false);
								});
								//連続コールテスト
								// changeAPI(ShoppingStartContext.data.token,bcode,singlenum)
								// 	.finally(() => {
								// 		setIsDisabled(false);
								// 		setIsRequesting(false);
								// 	});
							}
						}else{
							console.log("bnum:"+bnum);
							if(props.showItemNum[1] === bnum && props.showItemNum[2] !== "add"){
								console.log("changeAPI: nocall");
								console.log("個数変更なし");
								props.setShowItemNum([]);
								setIsDisabled(false);
								setIsRequesting(false);

								document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
									if (element) {
										element.classList.remove('is_show');
									}
								});
							}else{
								if(props.showItemNum[2] === "add"){ //追加
									console.log("keyplupurchaseAPI: call");
									//KeyPLU商品登録API
									keyplupurchaseAPI(ShoppingStartContext.data.token,bcode,bnum)
										.finally(() => {
											setIsDisabled(false);
											setIsRequesting(false);
										});
								}else{ //変更
									console.log("changeAPI: call");
									//商品個数変更API
									changeAPI(ShoppingStartContext.data.token,bcode,bnum)
									.finally(() => {
										setIsDisabled(false);
										setIsRequesting(false);
									});
									//連続コールテスト
									// changeAPI(ShoppingStartContext.data.token,bcode,bnum)
									// 	.finally(() => {
									// 		setIsDisabled(false);
									// 		setIsRequesting(false);
									// 	});
								}
							}
						}
					}
				}, 300);

				props.setSoundState("se08_se");
			} else {
				console.log("changeAPI: nocall");
				setIsDisabled(false);
				setIsRequesting(false);
			}
		} else {
			console.log("changeNum_btn: 無効");
		}
	}
}


//----------------------------------------
//商品個数変更API：レスポンス
//----------------------------------------

const [delItemFlg, setDelItemFlg] = useState(false)

//商品個数変更API：レスポンス
useEffect(() => {
	if(changeData){
		if (changeData.data) { //SUCCESS
			console.log(changeData);
			// console.log(changeData.data.sumItemCount);
			// console.log(props.shoppingData);
			// console.log(props.shoppingData.data.sumItemCount);
			if(props.shoppingData.data){
				if(props.shoppingData.data.sumItemCount !== changeData.data.sumItemCount){
					props.setShoppingData(changeData);
					if(props.showItemNum[2] === "add"){
						props.setShowItemNum([]);
						setTimeout(function(){
							setDelItemFlg(false);
							props.setShowItemNum([]);
							setIsDisabled(false);
						}, 400);
					}else{
						props.setShowItemNum([]);
						setTimeout(function(){
							setDelItemFlg(true);
							props.setShowItemNum(["","","change"]);
							console.log("change modal: show");
						}, 400);
						setTimeout(function(){
							setDelItemFlg(false);
							props.setShowItemNum([]);
							setIsDisabled(false);
							console.log("change modal: hide");

							setTimeout(function(){
								document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
									if (element) {
										element.classList.remove('is_show');
									}
								});
								try {
									let element = document.getElementById('changeNumModal');
									if (element) {
										element.remove();
									}
								} catch (error) {
									console.error("changeNumModalの削除エラー:", error);
								}
							}, 600);
						}, 1000);
						// se03_item_change_controls.stop();
						props.setSoundState("se03_item_change");
						// se03_item_change();
					}
				}
			}else{
				props.setShoppingData(changeData);
				setDelItemFlg(true);
				if(props.showItemNum[2] === "add"){
					props.setShowItemNum([]);
					setTimeout(function(){
						setDelItemFlg(false);
						props.setShowItemNum([]);
						setIsDisabled(false);
					}, 400);
				}else{
					props.setShowItemNum([]);
					setTimeout(function(){
						setDelItemFlg(true);
						props.setShowItemNum(["","","change"]);
						console.log("change modal: show");
					}, 400);
					setTimeout(function(){
						setDelItemFlg(false);
						props.setShowItemNum([]);
						setIsDisabled(false);
						console.log("change modal: hide");
						setTimeout(function(){
							document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
								if (element) {
									element.classList.remove('is_show');
								}
							});
							try {
								let element = document.getElementById('changeNumModal');
								if (element) {
									element.remove();
								}
							} catch (error) {
								console.error("changeNumModalの削除エラー:", error);
							}
						}, 600);
					}, 1000);
					// se03_item_change_controls.stop();
					props.setSoundState("se03_item_change");
					// se03_item_change();
				}
			}
		}else{ //ERROR
			console.log(`【changeAPI】 errorCode: ${changeData.errorCode}`);
			console.log(`【changeAPI】 errorMessage: ${changeData.errorMessage}`);
			console.log(`【changeAPI】 isSuccess: ${changeData.isSuccess}`);

			if(changeData.errorCode === "26"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${changeData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_26]);
				// props.setErr([true,`${changeData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[26];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[26]`]);
			}else if(changeData.errorCode === "27"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${changeData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_27]);
				// props.setErr([true,`${changeData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[27];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[27]`]);
			}else{
				// props.setErrNum(`${changeData.errorCode}`);
				// props.setShowModal(true);
				// props.setErrTxt(`${changeData.errorMessage}`);
				setTimeout(function(){
					props.setErrFlg(true);
					props.setErr([true,`${changeData.errorCode}`,`${changeData.errorMessage}`]);
				}, 300);
				setDelItemFlg(false);
				props.setShowItemNum([]);
				setIsDisabled(false);
			}
		}
	}else{
		// console.log("えええ");
		console.log("changeData: No Data");
	}
	if(changeError){
		console.log("changeError");
		console.log(changeError);
		props.setErrFlg(true);
		props.setErr([true,``, process.env.REACT_APP_ERROR_MESSAGE_TIMEOUT]);
		// props.setErr([true,``,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// props.setErr([true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);

		setDelItemFlg(false);
		props.setShowItemNum([]);
		setIsDisabled(false);
	}
	if(changeLoading){
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.add('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.add('is_show');
		});
	}else{
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			if (element) {
				element.classList.remove('is_show');
			}
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			if (element) {
				element.classList.remove('is_show');
			}
		});
	}
}, [changeData,changeLoading,changeError]);


//----------------------------------------
//KeyPLU商品登録API：レスポンス
//----------------------------------------

//KeyPLU商品登録API：レスポンス
useEffect(() => {
	if(keyplupurchaseData){
		if (keyplupurchaseData.data) { //SUCCESS
			console.log(keyplupurchaseData);
			// console.log(keyplupurchaseData.data.sumItemCount);
			// console.log(props.shoppingData);
			// console.log(props.shoppingData.data.sumItemCount);
			if(props.shoppingData.data){
				if(props.shoppingData.data.sumItemCount !== keyplupurchaseData.data.sumItemCount){
					props.setShoppingData(keyplupurchaseData);
					if(props.showItemNum[2] === "add"){
						props.setShowItemNum([]);
						setTimeout(function(){
							setDelItemFlg(false);
							props.setShowItemNum([]);
							setIsDisabled(false);

						}, 400);
					}else{
						props.setShowItemNum([]);
						setTimeout(function(){
							setDelItemFlg(true);
							props.setShowItemNum(["","","change"]);
							console.log("change modal: show");
						}, 400);
						setTimeout(function(){
							setDelItemFlg(false);
							props.setShowItemNum([]);
							setIsDisabled(false);
							console.log("change modal: hide");


							setTimeout(function(){
								document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
									if (element) {
										element.classList.remove('is_show');
									}
								});
								try {
									let element = document.getElementById('changeNumModal');
									if (element) {
										element.remove();
									}
								} catch (error) {
									console.error("changeNumModalの削除エラー:", error);
								}
							}, 600);
						}, 1000);
						// se03_item_change_controls.stop();
						props.setSoundState("se03_item_change");
						// se03_item_change();
					}
				}
			}else{
				props.setShoppingData(keyplupurchaseData);
				setDelItemFlg(true);
				if(props.showItemNum[2] === "add"){
					props.setShowItemNum([]);
					setTimeout(function(){
						setDelItemFlg(false);
						props.setShowItemNum([]);
						setIsDisabled(false);

					}, 400);
				}else{
					props.setShowItemNum([]);
					setTimeout(function(){
						setDelItemFlg(true);
						props.setShowItemNum(["","","change"]);
						console.log("change modal: show");
					}, 400);
					setTimeout(function(){
						setDelItemFlg(false);
						props.setShowItemNum([]);
						setIsDisabled(false);
						console.log("change modal: hide");


						setTimeout(function(){
							document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
								if (element) {
									element.classList.remove('is_show');
								}
							});
							try {
								let element = document.getElementById('changeNumModal');
								if (element) {
									element.remove();
								}
							} catch (error) {
								console.error("changeNumModalの削除エラー:", error);
							}
						}, 600);
					}, 1000);
					// se03_item_change_controls.stop();
					props.setSoundState("se03_item_change");
					// se03_item_change();
				}
			}
		}else{ //ERROR
			console.log(`【keyplupurchaseAPI】 errorCode: ${keyplupurchaseData.errorCode}`);
			console.log(`【keyplupurchaseAPI】 errorMessage: ${keyplupurchaseData.errorMessage}`);
			console.log(`【keyplupurchaseAPI】 isSuccess: ${keyplupurchaseData.isSuccess}`);

			if(keyplupurchaseData.errorCode === "26"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${keyplupurchaseData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_26]);
				// props.setErr([true,`${keyplupurchaseData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[26];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[26]`]);
			}else if(keyplupurchaseData.errorCode === "27"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${keyplupurchaseData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_27]);
				// props.setErr([true,`${keyplupurchaseData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[27];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[27]`]);
			}else{
				// props.setErrNum(`${keyplupurchaseData.errorCode}`);
				// props.setShowModal(true);
				// props.setErrTxt(`${keyplupurchaseData.errorMessage}`);
				setTimeout(function(){
					props.setErrFlg(true);
					props.setErr([true,`${keyplupurchaseData.errorCode}`,`${keyplupurchaseData.errorMessage}`]);
				}, 300);
				setDelItemFlg(false);
				props.setShowItemNum([]);
				setIsDisabled(false);
			}
		}
	}else{
		// console.log("えええ");
		console.log("keyplupurchaseData: No Data");
	}
	if(keyplupurchaseError){
		console.log("keyplupurchaseError");
		console.log(keyplupurchaseError);
		props.setErrFlg(true);
		props.setErr([true,``, process.env.REACT_APP_ERROR_MESSAGE_TIMEOUT]);
		// props.setErr([true,``,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// props.setErr([true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);

		setDelItemFlg(false);
		props.setShowItemNum([]);
		setIsDisabled(false);
	}
	if(keyplupurchaseLoading){
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.add('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.add('is_show');
		});
	}else{
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			if (element) {
				element.classList.remove('is_show');
			}
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			if (element) {
				element.classList.remove('is_show');
			}
		});
	}
}, [keyplupurchaseData,keyplupurchaseLoading,keyplupurchaseError]);


//----------------------------------------
//数量追加・変更モーダル：現在位置へスクロール
//----------------------------------------

useEffect(() => {
	if(props.showItemNum){
		console.log("props.showItemNum");
		console.log(props.showItemNum);
		if(props.showItemNum.length !== 0 && props.showItemNum[2] !== "add" && props.showItemNum[2] !== "change"){
			let scroll_id = "";
			for(let i = 1; i <= 99; i++) {
				let elementId = `cn${i}`;
				let element = document.getElementById(elementId);
				if(element && element.classList.contains('is_active')) {
					scroll_id = element;
					break; // is_active クラスを持つ最初の要素を見つけたらループを終了
				}
			}
			if (scroll_id !== "") {
			// getBoundingClientRect()は、ビューポートに対する要素の位置を提供します。
			// しかし、ページ全体に対してスクロールするには、現在のスクロール位置を考慮に入れる必要があります。
			// var topPosition = element.getBoundingClientRect().top + window.pageYOffset;
			var topPosition = scroll_id.offsetTop - 64;
				console.log("topPosition: " + topPosition);
			// scrollToメソッドでその位置まで即座にスクロール
			// window.scrollTo({
			document.querySelector(".changeNum_wrap").scrollTo({
			top: topPosition, // Y軸の位置
			behavior: 'auto' // またはこのプロパティを省略して即座にスクロール
			});
			}
			// }
		}else if(props.showItemNum.length !== 0 && props.showItemNum[2] === "add"){
			setIsDisabled(false);
			setIsRequesting(false);
		}else if(props.showItemNum.length !== 0 && props.showItemNum[2] === "change"){
			setIsDisabled(false);
			setIsRequesting(false);
		}
	}
}, [props.showItemNum]);


return (
	<AnimatePresence>
	{props.showItemNum.length && (
	<>
	{
		(() => {
			console.log("props.showItemNum[2]: "+props.showItemNum[2]);
			// if (props.showItemNum.length !== 0 && delItemFlg === false) {
				console.log("delItemFlg: "+delItemFlg);
				console.log("props.showItemNum:");
				console.log(props.showItemNum);
				console.log(props.showItemNum.length);
			// if (props.showItemNum.length !== 0 && delItemFlg === false) {
			// if (props.showItemNum.length !== 0 && (props.showItemNum[2] === "" || props.showItemNum[2] === "add") && delItemFlg === false) {
			if (props.showItemNum.length !== 0 && props.showItemNum[2] !== "change" && delItemFlg === false) {
			// if (props.showItemNum.length !== 0 && delItemFlg === false) {
				return(
					// {props.showItemNum.length ? (
					<section id="changeNum" className={`changeNumBox ${props.showItemNum.length !== 0 ? 'is_active' : ''}`}>
					<motion.div className="changeNum"
						initial={'initial'}
						animate={'animate'}
						exit={'hidden'}
						variants={changeMotion01}
						transition={{duration: 0.3, ease: 'easeOut'}}
					>
						<div className="changeNum_head">
							<p className="changeNum_tit">数量</p>
							<a className="changeNum_closeBtn" onClick={closeModal}>
								<img src="/images/btn_close01.svg" alt="" width="24" height="24" />
							</a>
						</div>
						<div className="changeNum_wrap">
						{Array.from({ length: 99 }, (_, i) => i + 1).map((number) => (
							<div key={number} id={`cn${number}`}
								className={`changeNum_btn ${props.showItemNum[1] === number ? 'is_active' : ''} ${isDisabled ? 'disabled' : ''}`}
								onClick={() => onSelectNum(number)} style={{ pointerEvents: isDisabled ? 'none' : 'auto', cursor: isDisabled ? 'default' : 'pointer' }}>
								<span>
								<img src="/images/icn_check_aeon.svg" alt="" width="24" height="24" />
								</span>
								{number}
							</div>
						))}
							{/* <a id="cn1" className={`changeNum_btn ${props.showItemNum[1] === 1 ? 'is_active' : ''}`} onClick={()=> onSelectNum(1)}>
								<span>
									<img src="/images/icn_check_aeon.svg" alt="" width="24" height="24" />
								</span>
							1</a>
							<a id="cn2" className={`changeNum_btn ${props.showItemNum[1] === 2 ? 'is_active' : ''}`} onClick={()=> onSelectNum(2)}>
								<span>
									<img src="/images/icn_check_aeon.svg" alt="" width="24" height="24" />
								</span>
							2</a>
							<a id="cn3" className={`changeNum_btn ${props.showItemNum[1] === 3 ? 'is_active' : ''}`} onClick={()=> onSelectNum(3)}>
								<span>
									<img src="/images/icn_check_aeon.svg" alt="" width="24" height="24" />
								</span>
							3</a>
							<a id="cn4" className={`changeNum_btn ${props.showItemNum[1] === 4 ? 'is_active' : ''}`} onClick={()=> onSelectNum(4)}>
								<span>
									<img src="/images/icn_check_aeon.svg" alt="" width="24" height="24" />
								</span>
							4</a>
							<a id="cn5" className={`changeNum_btn ${props.showItemNum[1] === 5 ? 'is_active' : ''}`} onClick={()=> onSelectNum(5)}>
								<span>
									<img src="/images/icn_check_aeon.svg" alt="" width="24" height="24" />
								</span>
							5</a>
							<a id="cn6" className={`changeNum_btn ${props.showItemNum[1] === 6 ? 'is_active' : ''}`} onClick={()=> onSelectNum(6)}>
								<span>
									<img src="/images/icn_check_aeon.svg" alt="" width="24" height="24" />
								</span>
							6</a>
							<a id="cn7" className={`changeNum_btn ${props.showItemNum[1] === 7 ? 'is_active' : ''}`} onClick={()=> onSelectNum(7)}>
								<span>
									<img src="/images/icn_check_aeon.svg" alt="" width="24" height="24" />
								</span>
							7</a>
							<a id="cn8" className={`changeNum_btn ${props.showItemNum[1] === 8 ? 'is_active' : ''}`} onClick={()=> onSelectNum(8)}>
								<span>
									<img src="/images/icn_check_aeon.svg" alt="" width="24" height="24" />
								</span>
							8</a>
							<a id="cn9" className={`changeNum_btn ${props.showItemNum[1] === 9 ? 'is_active' : ''}`} onClick={()=> onSelectNum(9)}>
								<span>
									<img src="/images/icn_check_aeon.svg" alt="" width="24" height="24" />
								</span>
							9</a>
							<a id="cn10" className={`changeNum_btn ${props.showItemNum[1] === 10 ? 'is_active' : ''}`} onClick={()=> onSelectNum(10)}>
								<span>
									<img src="/images/icn_check_aeon.svg" alt="" width="24" height="24" />
								</span>
							10</a>
							<a id="cn11" className={`changeNum_btn ${props.showItemNum[1] === 11 ? 'is_active' : ''}`} onClick={()=> onSelectNum(11)}>
								<span>
									<img src="/images/icn_check_aeon.svg" alt="" width="24" height="24" />
								</span>
							11</a>
							<a id="cn12" className={`changeNum_btn ${props.showItemNum[1] === 12 ? 'is_active' : ''}`} onClick={()=> onSelectNum(12)}>
								<span>
									<img src="/images/icn_check_aeon.svg" alt="" width="24" height="24" />
								</span>
							12</a>
							<a id="cn13" className={`changeNum_btn ${props.showItemNum[1] === 13 ? 'is_active' : ''}`} onClick={()=> onSelectNum(13)}>
								<span>
									<img src="/images/icn_check_aeon.svg" alt="" width="24" height="24" />
								</span>
							13</a>
							<a id="cn14" className={`changeNum_btn ${props.showItemNum[1] === 14 ? 'is_active' : ''}`} onClick={()=> onSelectNum(14)}>
								<span>
									<img src="/images/icn_check_aeon.svg" alt="" width="24" height="24" />
								</span>
							14</a>
							<a id="cn15" className={`changeNum_btn ${props.showItemNum[1] === 15 ? 'is_active' : ''}`} onClick={()=> onSelectNum(15)}>
								<span>
									<img src="/images/icn_check_aeon.svg" alt="" width="24" height="24" />
								</span>
							15</a>
							<a id="cn16" className={`changeNum_btn ${props.showItemNum[1] === 16 ? 'is_active' : ''}`} onClick={()=> onSelectNum(16)}>
								<span>
									<img src="/images/icn_check_aeon.svg" alt="" width="24" height="24" />
								</span>
							16</a>
							<a id="cn17" className={`changeNum_btn ${props.showItemNum[1] === 17 ? 'is_active' : ''}`} onClick={()=> onSelectNum(17)}>
								<span>
									<img src="/images/icn_check_aeon.svg" alt="" width="24" height="24" />
								</span>
							17</a>
							<a id="cn18" className={`changeNum_btn ${props.showItemNum[1] === 18 ? 'is_active' : ''}`} onClick={()=> onSelectNum(18)}>
								<span>
									<img src="/images/icn_check_aeon.svg" alt="" width="24" height="24" />
								</span>
							18</a>
							<a id="cn19" className={`changeNum_btn ${props.showItemNum[1] === 19 ? 'is_active' : ''}`} onClick={()=> onSelectNum(19)}>
								<span>
									<img src="/images/icn_check_aeon.svg" alt="" width="24" height="24" />
								</span>
							19</a>
							<a id="cn20" className={`changeNum_btn ${props.showItemNum[1] === 20 ? 'is_active' : ''}`} onClick={()=> onSelectNum(20)}>
								<span>
									<img src="/images/icn_check_aeon.svg" alt="" width="24" height="24" />
								</span>
							20</a> */}
						</div>
					</motion.div>
					<motion.div className="changeNumBox_bg" onClick={closeModalNoSound}
						initial={'initial'}
						animate={'animate'}
						exit={'hidden'}
						variants={noBarcode_cover}
						transition={{duration: 0.35, ease: 'linear'}}
					></motion.div>
					</section>

					// ) : ( // showModalがfalseの場合はModal非表示
					// 	<></>
					// )}
				)
			}
			// if (delItemFlg === true && props.showItemNum[2] !== "add") {
			if (delItemFlg === true && props.showItemNum[2] === "change") {
				return (
					<section id="changeNumModal" className="modalBox">
						<div className="modalBox_wrap">
					<motion.div className="changeNumComp"
						initial={'initial'}
						animate={'animate'}
						exit={'hidden'}
						variants={changeMotion02}
						transition={{duration: 0.5, delay: 0, ease: 'easeInOut'}}
					>
						<figure className="changeNumComp_img">
							<img src="/images/icn_check_white.svg" alt="" width="48" height="48"/>
						</figure>
						<p className="changeNum_tit">数量変更しました</p>
					</motion.div>
						</div>
					</section>
				)
			}
		})()
	}

	</>
	)}
	</AnimatePresence>
)

}
